export default __webpack_public_path__ + "static/drinking_fountain_w.771f4206bf10a3e47d651b21e84a7925.svg";